import {apiKey, getLogger} from '@client/services/sdk';
// eslint-disable-next-line import/no-cycle
import {
  requestInterceptorFulfilledHandler,
  requestInterceptorRejectedHandler,
  responseInterceptorFulfilledHandler,
  responseInterceptorRejectedHandler,
} from '@client/interceptors';
import {ClientService, NewAggregationInstitution, PlaidAccount} from '@simpleinvest/ms-client-sdk';
import {SourcePlatform} from '@simpleinvest/ms-core-sdk';

export default {
  getClientServiceInstance({logger = getLogger()} = {}): ClientService {
    return new ClientService({
      apiKey,
      sourceInfo: {platform: SourcePlatform.ClientPlatform},
      interceptors: {
        requestInterceptor: requestInterceptorFulfilledHandler,
        requestRejectedInterceptor: requestInterceptorRejectedHandler,
        responseInterceptor: responseInterceptorFulfilledHandler,
        responseRejectedInterceptor: responseInterceptorRejectedHandler,
      },
      logger,
    });
  },

  async save(institution: NewAggregationInstitution): Promise<PlaidAccount[]> {
    const service: ClientService = await this.getClientServiceInstance();

    return service.saveLinkedInstitution({institution});
  },
};
